/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export enum ConnectorTypes {
  ctNone,
  ctAnd,
  ctOr,
};

export enum OperatorTypes {
  otEqualTo,
  otGreaterThan,
  otLessThan,
  otGreaterThanEqualTo,
  otLessThanEqualTo,
  otBetween,
  otIn,
  otLike,
};

export class reportfilter extends IceEntity {
  report_filter_key: string = "";
  connectortype: ConnectorTypes = ConnectorTypes.ctNone;
  tablename: string = "";
  columnname: string = "";
  operatortype: OperatorTypes = OperatorTypes.otEqualTo;
  value: string = "";
  disabled: boolean = false;

  private data: string[] = [];

  constructor(cpy?: reportfilter) {
    super();

    if (cpy != null) {
      // skip primary key
      this.connectortype = cpy.connectortype;
      this.tablename = cpy.tablename;
      this.columnname = cpy.columnname;
      this.operatortype = cpy.operatortype;
      this.value = cpy.value;
      this.disabled = cpy.disabled;
      this.data = cpy.data;
    }
  }

  public gettablename(): string {
    return "REPORT_FILTER";
  }

  addData(dat: string): void {
    this.data.push(dat);
  }

  getData(index: number): string {
    if (index >= 0 && index < this.data.length)
      return this.data[index];
    else
      return "";
  }

  setData(index: number, dat: string): void  {
    if (index >= 0 && index < this.data.length)
      this.data[index] = dat;
  }

  getDataCount(): number {
    return this.data.length;
  }

  resetData(): void {
    this.data = [];
  }

  removeData(index): void {
    if (index >= 0 && index < this.data.length)
      this.data.splice(index, 1);
  }

  copyAllData(datAry: string[]): void {
     this.data = this.data.concat(datAry);
  }

  getAllData(): string[] {
    return this.data;
  }

  getOperatorDescription(opType: OperatorTypes): string {
    switch (opType) {
      case OperatorTypes.otEqualTo:
        return "= Equal To";
      case OperatorTypes.otGreaterThan:
        return "> Greater Than";
      case OperatorTypes.otLessThan:
        return "< Less Than";
      case OperatorTypes.otGreaterThanEqualTo:
        return ">= Greater Than Equal To";
      case OperatorTypes.otLessThanEqualTo:
        return "<= Less Than Equal To";
      case OperatorTypes.otBetween:
        return "Between";
      case OperatorTypes.otIn:
        return "In";
      case OperatorTypes.otLike:
        return "Like";
    }
    return "";
  }

  getConnectorDescription(connType: ConnectorTypes): string {
    switch (connType) {
      case ConnectorTypes.ctNone:
        return "(NONE)";
      case ConnectorTypes.ctAnd:
        return "And";
      case ConnectorTypes.ctOr:
        return "Or";
    }
    return "";
  }

  getFullName(): string {

    let fullName = "";
    if (this.tablename != null && this.tablename.length > 0)
      fullName = this.tablename + "." + this.columnname;
    else
      fullName = this.columnname;

    return fullName;
  }

  getOperatorFromText(operTypeText: string): OperatorTypes {
    if (operTypeText == null || operTypeText.length == 0)
      return OperatorTypes.otEqualTo;

    let lowerText = operTypeText.toLowerCase(); 
    if (lowerText == "= equal to")
      return OperatorTypes.otEqualTo;
    else if (lowerText == "> greater than")
      return OperatorTypes.otGreaterThan;
    else if (lowerText == "< less than")
      return OperatorTypes.otLessThan;
    else if (lowerText == ">= greater than equal to")
      return OperatorTypes.otGreaterThanEqualTo;
    else if (lowerText == "<= less than equal to")
      return OperatorTypes.otLessThanEqualTo;
    else if (lowerText == "between")
      return OperatorTypes.otBetween;
    else if (lowerText == "in")
      return OperatorTypes.otIn;
    else if (lowerText == "like")
      return OperatorTypes.otLike;

    return OperatorTypes.otEqualTo;
  }

  getConnectorFromText(connType: string): ConnectorTypes {
    if (connType == null || connType.length == 0)
      return ConnectorTypes.ctNone;

    let lowerText = connType.toLowerCase(); 
    if (lowerText == "none")
      return ConnectorTypes.ctNone;
    else if (lowerText == "and")
      return ConnectorTypes.ctAnd;
    else if (lowerText == "or")
      return ConnectorTypes.ctOr;

    return ConnectorTypes.ctNone;
  }
}
